export const SESSION_PREVIEW_KEY = {
  PERIOD_TIME: 'PERIOD_TIME',
  GROUP_SESSION_INFO: 'GROUP_SESSION_INFO',
  PRIVATE_SESSION_PREVIEW: 'PRIVATE_SESSION_PREVIEW',
  SESSION_DATE: 'SESSION_DATE',
  SESSION_INFO: 'SESSION_INFO',
  SESSION_PERIOD_TIME: 'SESSION_PERIOD_TIME',
}
